module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/icons/social/instagram-default@2x.png?56f74136f83ecd27ffd38948bd45262f";